module.exports = __webpack_public_path__ + "img/rural-banner2.37ab39b9.jpg";